import Icon, { BaseIconProps } from './Icon'
function BackArrowIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16" {...props}>
        <path d="M8.8 15.51a1.72 1.72 0 0 0 0-2.37L5.46 9.65h12.93a1.68 1.68 0 0 0 0-3.36H5.51L8.8 2.86a1.72 1.72 0 0 0 0-2.37 1.57 1.57 0 0 0-2.27 0L.47 6.81A1.75 1.75 0 0 0 0 8a1.7 1.7 0 0 0 .47 1.18l6.06 6.33a1.57 1.57 0 0 0 2.27 0" />
      </svg>
    </Icon>
  )
}
export default BackArrowIcon
